import React, { useMemo } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit';

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: 40,
  background: 'var(--color-surface)',
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px 8px 8px',
  marginTop: '2px'
}));

const SelectBox = ({ selected, onClick, label }) => {
  const visible = useMemo(() => selected?.slice(0, 2), [selected]);
  const remaining = useMemo(() => selected?.length - 2, [selected]);

  return (
    <>
      {!!label && (
        <Typography sx={{ fontSize: 14 }}>{label}</Typography>
      )}
      <Container>
        {selected?.length ? (
          <Box>
            {visible?.map((item) => (
              <Chip
                key={`${Math.random()}_${item.key}`}
                size="small"
                label={item.label}
                variant="outlined"
              sx={{
                  fontWeight: 500,
                  backgroundColor: 'var(--color-main-light)',
                  borderColor: 'var(--color-main-border)',
                  borderRadius: '4px',
                  paddingLeft: '4px',
                  paddingRight: '4px',
                  mr: 1,
                }}
              />
            ))}

            {remaining > 0 && (
              <Chip
                size="small"
                label={`+${remaining} more`}
                variant="outlined"
                sx={{
                  fontWeight: 500,
                  backgroundColor: 'var(--color-main-light)',
                  borderColor: 'var(--color-main-border)',
                  borderRadius: '4px',
                  paddingLeft: '4px',
                  paddingRight: '4px',
                }}
              />
            )}
          </Box>
        ) : (
          <Box>
            <Chip
              size="small"
              label="0 selected"
              variant="outlined"
              sx={{
                fontWeight: 500,
                backgroundColor: 'var(--color-main-light)',
                borderColor: 'var(--color-main-border)',
                borderRadius: '4px',
                paddingLeft: '4px',
                paddingRight: '4px',
              }}
            />
          </Box>
        )}

        <Box sx={{ display: 'flex', cursor: 'pointer' }} onClick={onClick}>
          <EditIcon color="primary" fontSize="small" />
          <Typography fontSize={14} ml="4px" fontWeight={600} color="primary">Edit</Typography>
        </Box>
      </Container>
    </>
  );
}

export default SelectBox;
